import headerHTML from "../../components/header.html";
import footerHTML from "../../components/footer.html";

import Header from "./modules/Header";
import MobileNav from "./modules/MobileNav";
import blogSwiper from "./modules/blogSwiper";
import testimonialSwiper from "./modules/testimonialSwiper";
import partnersSwiper from "./modules/partnersSwiper";

import gsap from "gsap";
import WOW from "wow.js";
import ScrollTrigger from "gsap/dist/ScrollTrigger";

// const animations = new Animations();
gsap.registerPlugin(ScrollTrigger);

const initApp = () => {
  new WOW().init();
  
  // Header
  const headerElement = document.querySelector("#header");
  if (headerElement) {
    new Header(headerElement);
  }

  // Mobile Navigation
  const mobileNav = document.querySelector("#mobileNav");
  new MobileNav(mobileNav);

  // Blog Slider
  const blogSlider = document.querySelector(".blog-swiper .swiper");
  if (blogSlider != null) {
    new blogSwiper(blogSlider);
  }

  // Testimonial Slider
  const testimonialSlider = document.querySelector(".testimonial-swiper .swiper");
  if (testimonialSlider != null) {
    new testimonialSwiper(testimonialSlider);
  }

  // Partners Slider
  const partnersSlider = document.querySelector(".partner-swiper .swiper");
  if (partnersSlider != null) {
    new partnersSwiper(partnersSlider);
  }
};

if (document.readyState === "loading") {
  // DOM is still loading
  document.addEventListener("DOMContentLoaded", () => {
    document.getElementById("headerWrapper").innerHTML = headerHTML;
    document.getElementById("footerWrapper").innerHTML = footerHTML;
    initApp();
  });
} else {
  // DOM is already loaded
  document.getElementById("headerWrapper").innerHTML = headerHTML;
  document.getElementById("footerWrapper").innerHTML = footerHTML;
  initApp();
}